import "../../../components/asset_cropper.js";

(function () {
  "use strict";

  Sparkle.PageBuilder.DeviceCropperTab = function (container, asset, deviceName, defaultRatios, activeCropIcon) {
    var assetData = asset.variants[deviceName];
    var cropRatio = assetData ? assetData.type : "none";
    var imageToCrop = container.find("[data-behaviour~=cropper]")[0];
    var sliderWrap = container.find(".cr-slider-wrap");
    var currentCropper;

    this.enabled = false;
    this.enable = function () {
      container.show();
      enableCropper();
      this.enabled = true;
    };

    // BEHAVIOUR
    container.on("change", "[data-behaviour~=select-cropper-ratio]", handleCroppingRatioSelected);
    sliderWrap.find("[data-method=zoom]").on("input", handleZoomChange);
    container.on("change", "[data-method=set-max-size] input", handleCropLimitsChange);

    // EVENT HANDLERS
    function handleCroppingRatioSelected(event) {
      cropRatio = jQuery(this).val();

      if (currentCropper !== undefined) {
        currentCropper.destroy();
        var sliderMin = sliderWrap.find("[data-method=zoom]").attr("min");
        sliderWrap.find("[data-method=zoom]").val(sliderMin).trigger("input");
      }

      toggleActiveIcon();
      enableCropper();
    }

    function handleZoomChange(event) {
      var slider = jQuery(this);
      updateZoomFill(slider);
      if (currentCropper) {
        currentCropper.zoom(slider.val());
      }
    }

    function handleCropLimitsChange(event) {
      updateAssetCropLimits();
    }

    // HELPER FUNCTIONS
    function enableCropper() {
      if (cropRatio === "none") {
        sliderWrap.hide();
        updateAssetCroppedImage({ height: null, width: null, x_offset: null, y_offset: null });
      } else {
        sliderWrap.show();

        var options = {
          onCrop: updateAssetCroppedImage,
        };

        if (cropRatio !== "custom") {
          options.aspectRatio = defaultRatios[cropRatio].width / defaultRatios[cropRatio].height;
        }
        currentCropper = new Sparkle.AssetCropper(imageToCrop, assetData, options);
      }
    }

    function toggleActiveIcon() {
      if (cropRatio === "none") {
        activeCropIcon.hide();
      } else {
        activeCropIcon.show();
      }
    }

    function updateZoomFill(slider) {
      var percent =
        Math.ceil(((slider.val() - slider.attr("min")) / (slider.attr("max") - slider.attr("min"))) * 100) + "%";
      sliderWrap.find(".zoom-fill").css({ width: percent });
      sliderWrap.find(".zoom-thumb").css({ left: percent });
    }

    function updateAssetCroppedImage(data) {
      updateAssetVariant(data);
      updateAssetCropLimits();
    }

    function initAssetCropLimits() {
      var height = assetData ? assetData.max_height : defaultRatios[cropRatio].height;
      var width = assetData ? assetData.max_width : defaultRatios[cropRatio].width;

      container.find("[name=max_height]").val(height);
      container.find("[name=max_width]").val(width);
    }

    function updateAssetCropLimits() {
      var maxWidth = container.find("[name=max_width]").val() || defaultRatios[cropRatio].width;
      var maxHeight = container.find("[name=max_height]").val() || defaultRatios[cropRatio].height;

      updateAssetVariant({
        max_width: toPixelDimension(maxWidth),
        max_height: toPixelDimension(maxHeight),
      });
    }

    function updateAssetVariant(data) {
      data = jQuery.extend({}, asset.variants[deviceName], data, { type: cropRatio });

      // Whitelist the fields that go into the asset variant
      asset.variants[deviceName] = {
        height: data.height,
        max_height: data.max_height,
        max_width: data.max_width,
        type: data.type,
        width: data.width,
        x_offset: data.x_offset,
        y_offset: data.y_offset,
      };
    }

    function toPixelDimension(value) {
      return value ? Math.round(value) : null;
    }

    // INIT
    initAssetCropLimits();
    updateAssetCropLimits(); // Ensure default limits are set
    toggleActiveIcon();
  };
})();
